import { Delay } from 'classes';
import ODataUtil from 'utils/ODataUtil';

const apiEndpoint = "/Delay";

const getDelays = async function getDelays(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Delay;
  const endpoint = apiEndpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, { model, endpoint });
  return data;
}

export { getDelays };